import React from 'react';
import MicroLabel from '../components/MicroLabel';
import { dateDots } from '../format';

/**
 * Chapter 08 — the red poster slide.
 *
 * The one place in the system where the accent runs as a full field. Quotes the
 * latest AI-generated insight as a display statement.
 *
 * This chapter is not rendered at all when the user has no insights — see the
 * chapter list in `Story.jsx`, which drops it and renumbers the rest rather than
 * showing an empty poster.
 */
function Insight({ story }) {
  const insight = story?.latestInsight;

  return (
    <>
      <div className="story-poster-body">
        <p className="story-poster-quote">“{insight?.text}”</p>
      </div>

      <MicroLabel>
        Generated {dateDots(insight?.date)} · Read all insights in the detailed view
      </MicroLabel>
    </>
  );
}

export default Insight;
